import { Component, OnInit } from '@angular/core';
import { Campus } from 'src/app/core/models/api/campus.model';
import { CampusResourceService } from 'src/app/core/services/api/campus-resource.service';
import { CampusService } from 'src/app/core/services/api/campus.service';

@Component({
    selector: 'app-footer-menu',
    templateUrl: './footer-menu.component.html',
    styleUrls: ['./footer-menu.component.scss']
})
export class FooterMenuComponent implements OnInit {

    public campus: Campus;

    public logoFSS    : string;
    public logoPartner: string;
    public urlFSS     : string;
    public urlPartner : string;

    public campusYear: number;
    public phone     : string;
    public schedule  : string;
    public mail      : string;
    public facebook  : string;
    public instagram : string;

    public urlLegalAdvice  : string;
    public urlCookiesPolicy: string;

    constructor(private campusService: CampusService, private campusResourceService: CampusResourceService) { }

    ngOnInit() { 

        this.campus = this.campusService.campusActive;
        this.getCampusResources();

    }

    getCampusResources() {

        this.logoPartner      = this.campusResourceService.findResource(this.campus.resources, 'logo-partner');
        this.urlPartner       = this.campusResourceService.findResource(this.campus.resources, 'url-partner');
        this.logoFSS          = this.campusResourceService.findResource(this.campus.resources, 'logo-fss');
        this.urlFSS           = this.campusResourceService.findResource(this.campus.resources, 'url-fss');
        this.campusYear       = +this.campusResourceService.findResource(this.campus.resources, 'campus-year');
        this.phone            = this.campusResourceService.findResource(this.campus.resources, 'contact-phone-normal');
        this.schedule         = this.campusResourceService.findResource(this.campus.resources, 'contact-schedule-normal');
        this.mail             = this.campusResourceService.findResource(this.campus.resources, 'contact-mail');
        this.facebook         = this.campusResourceService.findResource(this.campus.resources, 'contact-facebook');
        this.instagram        = this.campusResourceService.findResource(this.campus.resources, 'contact-instagram');
        this.urlLegalAdvice   = this.campusResourceService.findResource(this.campus.resources, 'url-legal-advice');
        this.urlCookiesPolicy = this.campusResourceService.findResource(this.campus.resources, 'url-cookies-policy');

    }

}
